<app-obj-select-and-edit
  [doDelete]="doDelete"
  [editorTemplate]="optionEditor"
  [label]="'Callee Entity'"
  [modifiedSelectedItem]="selectedKVPair?.value"
  [(orderedItems)]="objList"
  [(selectedKVPair)]="selectedKVPair"
  (duplicateClick)="duplicateClick()"
  (newClick)="newClick()"
>
  <ng-template #optionEditor let-index="id" let-item="item" let-kvPair>
    <p>Editing Option at Index: {{ this.selectedKVPair?.id }}</p>

    <app-callee-entity-editor
      *ngIf="selectedKVPair?.value !== undefined"
      [eventTypes]="eventTypes"
      [userDataArray]="userDataArray"
      [(obj)]="selectedKVPair"
      (objChange)="updateAndEmit()"
    >
    </app-callee-entity-editor>
  </ng-template>
</app-obj-select-and-edit>
